import { FC } from 'react'
import Page from '@/client/submodules/Page'
import { Infos } from './Infos'
import { PrivacyPolicyProps } from './types'

export const PrivacyPolicy: FC<PrivacyPolicyProps> = ({ seo, header, footer, content }) => (
  <Page seo={seo} header={header} footer={footer}>
    <Infos content={content} />
  </Page>
)
